import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import vertexShader from './shaders/vertex.glsl'
import fragmentShader from './shaders/fragment.glsl'

/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
 const textureLoader = new THREE.TextureLoader()
 const matcapTexture = textureLoader.load('/textures/metalMatcap.png')

/**
 * Meshes
 */

const boxGeo = new THREE.BoxGeometry(80,80,80)
const boxMat = new THREE.ShaderMaterial({
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
    side: THREE.DoubleSide,
    uniforms: {
        uTime: { value: 0 },
        uResolution: { value: [window.innerWidth, window.innerHeight] }
    }
})
const box = new THREE.Mesh(boxGeo, boxMat)
scene.add(box)

makeSphere(2.5,0,0,1)
makeSphere(-2.5,0,0,1)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(10, sizes.width / sizes.height, 0.1, 1000)
camera.position.y = 1    
camera.position.z = 35 
scene.add(camera)

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 5)
scene.add(ambientLight)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor( 0x1a1a1a )

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Animate camera
    camera.position.x = Math.sin(elapsedTime*0.1) * 30
    camera.position.z = Math.cos(elapsedTime*0.1) * 30
    camera.position.y = Math.sin(elapsedTime*0.1) *10

    // Update material
    boxMat.uniforms.uTime.value = elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

function makeSphere(x,y,z,s) {
    const sphereGeo = new THREE.SphereGeometry(s, 64, 64)

    const sphereMat = new THREE.MeshMatcapMaterial({
        matcap: matcapTexture
    })
    
    if (s > 0.1) {
        const sphere = new THREE.Mesh(sphereGeo, sphereMat)
        sphere.position.set(x,y,z)
        scene.add(sphere)

        makeSphere(x+(s+s/2),y,z,s-0.33)
        makeSphere(x-(s+s/2),y,z,s-0.33)
        makeSphere(x,y+(s+s/2),z,s-0.33)
        makeSphere(x,y-(s+s/2),z,s-0.33)
        makeSphere(x,y,z+(s+s/2),s-0.33)
        makeSphere(x,y,z-(s+s/2),s-0.33)
    }
}